import {h, Fragment} from "preact";
import {observer} from "mobx-preact";
import {useMemo, useState} from "preact/hooks";
import "./index.less";
import cx from "classnames";
import Theme from "../theme";
import {isMobile} from "@src/utils/device-utils";
import Link from "../link";
import intl from "react-intl-universal";
import {useEffect} from "preact/hooks";
import SignIn from "@src/business-components/sign-in";
import Layout from "@src/components/layout";
import Register from "@src/business-components/register";
import {$$tracker} from "@src/tracker";
import {OFFICIAL_SITE_URL} from "@src/constants/urls";


// const prefix = isMobile() ? "xfe-common-login-modal-mobile" : "xfe-common-login-modal";

const Modal = ({store, lang}) => {
  store.use();
  const [mobileStatus, setMobileStatus] = useState(window.innerWidth <= 745);
  useEffect(() => {
    window.addEventListener('resize', () => {
      setMobileStatus( window.innerWidth <= 745);
    });
  } ,[]);
  const prefix = useMemo(() => {
    return mobileStatus ? "xfe-common-login-modal-mobile" : "xfe-common-login-modal"
  }, [mobileStatus])
  if(mobileStatus) {
    return (
      <div className={cx(`${prefix}-modal`, !store?.visible && `${prefix}-modalHide`)}>
        <div className={cx(`${prefix}-modalContent`, !store?.visible && `${prefix}-modalContentHide`)}>
          <Theme>
            {store?.contentType === 0 && <Layout title={intl.get('PAGE.SIGN_IN.TITLE')} extra={<Link className={`${prefix}-btnClose`} onClick={store?.onClose}/>}>
              <SignIn needThirdLogin={store.needThirdLogin} bottom={
                <div className={'xfe-common-login-modal-mobile_other'}>
                  <a
                    href={`${OFFICIAL_SITE_URL}/${lang}/#/forgot-password`}
                    target={'_blank'}
                    onClick={() => {
                      $$tracker.forgetPwd();
                    }}
                  >
                    {intl.get('PAGE.SIGN_IN.FORGOT_PASSWORD.TEXT')}
                  </a>
                  <a onClick={() => store.onChangeContentType(1)} target={'_self'}>
                    {intl.get('PAGE.SIGN_IN.REGISTER.TEXT')}
                  </a>
                </div>
              }/></Layout>}
            {store?.contentType === 1 && <Layout title={intl.get('PAGE.REGISTER.TITLE')} extra={<Link className={`${prefix}-btnClose`} onClick={store?.onClose}/>}>
              <Register bottom={
                <div className={'xfe-common-login-modal-mobile_other'}
                     style={{justifyContent: "center"}}>
                  <a onClick={() => store.onChangeContentType(0)} target={'_self'}>
                    {intl.get('PAGE.REGISTER.SIGN_IN.TEXT')}<span className={'xfe-common-login-modal-link'} />
                  </a>
                </div>
              }/></Layout>}
            {/*{store?.contentType === 0 && <Login store={store?.login}/>}
              {store?.contentType === 1 && <Register store={store?.register}/>}*/}
            {/*<Link className={`${prefix}-btnClose`} onClick={store?.onClose}/>*/}
          </Theme>
        </div>
      </div>
    );
  }
  return (<div className={cx(`${prefix}-modal`, !store?.visible && `${prefix}-modalHide`)}>
    <div className={cx(`${prefix}-modalContent`, !store?.visible && `${prefix}-modalContentHide`)}>
        <Theme>
          <div className={`${prefix}-contentGroup`}>
            <div className={`${prefix}-content`}>
              {store?.contentType === 0 && <Layout title={intl.get('PAGE.SIGN_IN.TITLE')}>
                <SignIn needThirdLogin={store.needThirdLogin} bottom={
                  <div className={'xfe-common-login-modal-mobile_other'}>
                    <a
                      href={`${OFFICIAL_SITE_URL}/${lang}/#/forgot-password`}
                      target={'_blank'}
                      onClick={() => {
                        $$tracker.forgetPwd();
                      }}
                    >
                      {intl.get('PAGE.SIGN_IN.FORGOT_PASSWORD.TEXT')}
                    </a>
                    <a onClick={() => store.onChangeContentType(1)} target={'_self'}>
                      {intl.get('PAGE.SIGN_IN.REGISTER.TEXT')}
                    </a>
                  </div>
                }/></Layout>}
              {store?.contentType === 1 && <Layout title={intl.get('PAGE.REGISTER.TITLE')}>
                <Register bottom={
                  <div className={'xfe-common-login-modal-mobile_other bold'}
                       style={{justifyContent: "center", fontWeight: 600}}>
                    <a onClick={() => store.onChangeContentType(0)} target={'_self'}>
                      {intl.get('PAGE.REGISTER.SIGN_IN.TEXT')}<span className={'xfe-common-login-modal-link'} />
                    </a>
                  </div>
                }/></Layout>}
              {/*{store?.contentType === 0 && <Login store={store?.login}/>}
              {store?.contentType === 1 && <Register store={store?.register}/>}*/}
            </div>

            <Link className={`${prefix}-btnClose`} onClick={store?.onClose}/>
          </div>
        </Theme>
    </div>
  </div>);
};

export default observer(Modal);
